import { useRef, useEffect } from 'react';

/**
 * Custom hook for handling node clicks with drag detection
 * Prevents click handler from firing when user is dragging a node
 */
export const useNodeClickHandler = (onViewDetails, getPayload, isDraggingRef) => {
  const timeoutRef = useRef(null);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleClick = (e) => {
    // Only trigger on single click, not double click
    if (onViewDetails && e.detail === 1) {
      // Clear any pending timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        // Check if we're currently dragging (use ref if provided, fallback to window)
        const isDragging = isDraggingRef?.current ?? window.isDragging;
        if (!isDragging) {
          onViewDetails(getPayload());
        }
      }, 200);
    }
  };

  return handleClick;
};

export default useNodeClickHandler;
